import {
    CREATE_ACCESSORIES_PO_DETAILS_FAILURE,
    CREATE_ACCESSORIES_PO_DETAILS_REQUEST,
    CREATE_ACCESSORIES_PO_DETAILS_SUCCESS,
    CREATE_USER_FORM_ACCESSORIES_PO_DETAILS,
    DELETE_ACCESSORIES_PO_DETAILS_FAILURE,
    DELETE_ACCESSORIES_PO_DETAILS_REQUEST,
    DELETE_ACCESSORIES_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_PO_DETAILS_FAILURE,
    FETCH_ACCESSORIES_PO_DETAILS_REQUEST,
    FETCH_ACCESSORIES_PO_DETAILS_SUCCESS,
    ACCESSORIES_PO_DETAILS_USERFORM_RESET,
    UPDATE_ACCESSORIES_PO_DETAILS_FAILURE,
    UPDATE_ACCESSORIES_PO_DETAILS_REQUEST,
    UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_REQUEST,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_SUCCESS,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE,
    ACCESSORIES_PO_DETAILS_USERFORM_SELECTED_ROWS,
    UPDATE_ACCESSORIES_PO_REQUEST,
    UPDATE_ACCESSORIES_PO_SUCCESS,
    UPDATE_ACCESSORIES_PO_FAILURE,
    FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST,
    FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS,
    FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_FAILURE,
    FETCH_ACCESSORIES_PO_DETAILS_BY_ID_FAILURE,
    CREATE_USER_FORM_ACCESSORIES_PO_GENERATE_QTY
} from './accessoriesPODetails.actionsType';

export const ACCESSORIES_PO_DETAILS = 'accessoriesPODetails';

let initialState = {
    loading: false,
    accessoriesPODetailsById: [],
    accessoriesPODetails: [],
    userform: {
        fldIsCora: false,
        fldRate: 0,
        //fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldCostPerBag: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldShowAll: false,
        previousFldId: []
    },
    selectedAccessoriesDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    previousList: [],
    selectedRows: [],
    updatedList: [],
    groupList: [],
};

export let accessoriesPODetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_ACCESSORIES_PO_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_PO_DETAILS_BY_ID_REQUEST:
        case CREATE_ACCESSORIES_PO_DETAILS_REQUEST:
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST:
        case UPDATE_ACCESSORIES_PO_DETAILS_REQUEST:
        case DELETE_ACCESSORIES_PO_DETAILS_REQUEST:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST:
            return {
        ...state,
        loading: true,
        previousList: [],
        selectedRows: []
    };
        case UPDATE_ACCESSORIES_PO_REQUEST:
        case FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPODetails: updatePayload
            };
        case FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case FETCH_ACCESSORIES_PO_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesPODetailsById: updatePayload,
                
            };
        case UPDATE_ACCESSORIES_PO_SUCCESS: {
            return {
                ...state,
                loading: false,
                updatedList: updatePayload
            };
        }
        case CREATE_ACCESSORIES_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    // fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                previousList: []
            };
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDetails: updatePayload,
                userform: updatePayload,
                editAccessoriesPOList: [{
                    ...updatePayload,  
                    FldStyleNumber: updatePayload?.fldStyleNumber,
                    FldSubStylenumber: updatePayload?.tblPoNo.fldSubStyleName,
                    FldName: updatePayload?.tblSizeInfoAccessoriesItem.fldName,
                    FldColour: updatePayload?.fldColour,
                    FldSizeInfo: updatePayload?.fldSize,
                    FldBalanceQuantity: updatePayload?.fldQuantity,
                    FldRate: updatePayload?.fldRate,
                    FldBalanceQuantity: updatePayload?.fldBalanceQuantity,
                    FldFKSaleOrder: updatePayload?.fldFKSaleOrder,
                    FldFKAccessoriesMaster: updatePayload?.fldFKAccessoriesItem,
                    FldSaleOrderNumber:updatePayload?.fldSalesOrderNo,
                    FldFKStyle:updatePayload?.fldFKStyle,
                    FldFKHSNId:updatePayload?.tblHSNCode.fldId,
                    FldNettRequirement:updatePayload?.fldIIUOM,
                    FldFKSize: updatePayload?.fldFKAccessoriesSize

                }]
                /*userform: {
                    employee: updatePayload.fldFKEmployee,
                    designation: updatePayload.fldEmployeeDesgination,
                    roleInTeam: updatePayload.fldFKRolesInTeam
                }*/
            };
        case UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedAccessoriesDetails: {},
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    // fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                }
            };
        case DELETE_ACCESSORIES_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: []
                },
                selectedAccessoriesDetails: {}
            };
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload.ACP
            };
        case ACCESSORIES_PO_DETAILS_USERFORM_SELECTED_ROWS:
            return {
                ...state,
                loading: false,
                selectedRows: payload
            };
            case CREATE_USER_FORM_ACCESSORIES_PO_GENERATE_QTY:
                return {
                    ...state,
                    loading: false,
                    editAccessoriesPOList: payload
                }
        case FETCH_ACCESSORIES_PO_DETAILS_FAILURE:
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE:
        case CREATE_ACCESSORIES_PO_DETAILS_FAILURE:
        case UPDATE_ACCESSORIES_PO_DETAILS_FAILURE:
        case DELETE_ACCESSORIES_PO_DETAILS_FAILURE:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE:
        case UPDATE_ACCESSORIES_PO_FAILURE:
        case FETCH_ACCESSORIES_PO_DETAILS_BY_ID_FAILURE:
        case FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_ACCESSORIES_PO_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                },
                
            };
        case ACCESSORIES_PO_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldIsCora: false,
                    fldFKAccessoriesItem: state?.userform?.fldFKAccessoriesItem,
                    fldFKMillName: state?.userform?.fldFKMillName,
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    previousFldId: [],
                    fldShowAll: false,
                },
                selectedAccessoriesDetails: {},
                previousList: [],
                updatedList: [],
                editAccessoriesPOList: []
            };
        default:
            return state;
    }
};
